module.exports = __webpack_public_path__ + "static/Data-Editing-6c80559973ba18ce3f87b7df2f37ef66.png";